module.exports = __webpack_public_path__ + "img/offer-banner.4343b214.jpg";